import axios from 'axios';
// import { setSizotsaApiDetails,  } from '../../../actions/kaMetlhaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import { getQuoteRequestBody } from '../../../selectors/sizotsaFuneralCover/quote';
import { setSizotsaApiDetails } from '../../../actions/sizotsaFuneralCover/referenceData';
import { setQuoteDetailsStateValue } from '../../../actions/sizotsaFuneralCover/quote';

export const quoteService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        try{            
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.PENDING,name:'quoteService'}));
            const requestBody= getQuoteRequestBody(state)
            const response = await sendQuoteDetails(requestBody);
            
        if (response && response.status === httpStatusCode.OK) {
            store.dispatch(setQuoteDetailsStateValue({fieldType:'quotingResponse',value:response?.data}))
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.SUCCESS,name:'quoteService'}));
        } else {
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:'quoteService',content:"Unable to fetch the quote. Please try again later."}));
        }
    }
        catch(error){            
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:'quoteService',content:"Unable to fetch the quote. Please try again later."}));
        }
    })();
    return next(action);
};

const sendQuoteDetails = async (requestBody)=>{
        try {
            const response = await axios({
                url: 'om-api/sizotsa-funeral/get-quote',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                data: requestBody,
            });
            return response;
        } catch (error) {
            return null;
        }
}
